export default __webpack_public_path__ + "static/media/CarWhite.b078f7c3.png";